<template>
  <div class="kf-gap-note">
    <div v-if="showType && gap.type" class="kf-gap-note__row">
      <span class="kf-gap-note__label">Borrower type</span>
      <span>
        {{ gap.type_label || gap.type }}
        <code class="kf-code">{{ gap.type }}</code>
        <span v-if="gap.level_label" class="kf-muted"> · {{ gap.level_label }}</span>
      </span>
    </div>
    <div v-if="gap.needs && gap.needs.length" class="kf-gap-note__row">
      <span class="kf-gap-note__label">Add a template for</span>
      <span>
        <span v-for="(need, i) in gap.needs" :key="need.purpose">
          <span v-if="i" class="kf-muted">{{ i === gap.needs.length - 1 ? " or " : ", " }}</span>
          {{ need.label }} <code class="kf-code">{{ need.purpose }}</code>
        </span>
      </span>
    </div>
    <!-- Kinds the type allows but a rule holds back for them: a new template
         of that kind would be held back too, so it is not worth adding. -->
    <div v-for="held in gap.blocked || []" :key="held.purpose" class="kf-gap-note__row">
      <span class="kf-gap-note__label">Not worth adding</span>
      <span>
        {{ held.label }} <code class="kf-code">{{ held.purpose }}</code>:
        <span class="kf-muted">{{ held.why }}</span>
      </span>
    </div>
    <div v-if="gap.channels && gap.channels.length" class="kf-gap-note__row">
      <span class="kf-gap-note__label">On</span>
      <span>{{ either(gap.channels.map((c) => channelLabel(c.channel))) }}</span>
    </div>
    <div v-if="gap.tones && gap.tones.length" class="kf-gap-note__row">
      <span class="kf-gap-note__label">Tone</span>
      <span>{{ either(gap.tones.map((t) => TONE_WORDS[t] || t)) }}</span>
    </div>
    <div v-if="gap.why && gap.why.length" class="kf-gap-note__row">
      <span class="kf-gap-note__label">
        Why nothing fit<template v-if="gap.approved"> ({{ gap.approved }} approved)</template>
      </span>
      <ul class="kf-gap-note__why">
        <li v-for="line in gap.why" :key="line">{{ line }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
/**
 * A missing template, from notification/growth/reports.template_gap: the
 * borrower type and level no approved message fitted, the kinds of message
 * and channels that would have, the tones allowed, and why the approved
 * templates for the type were left out. Codes are shown next to the words,
 * so a new template can be set up with exactly those values.
 */
import { channelLabel } from "@/pages/karrofin/agent/common";

const TONE_WORDS = {
  friendly: "friendly",
  checkin: "check-in",
  benefit: "benefit",
  motivating: "motivating",
  urgency: "urgency",
};

export default {
  name: "KfTemplateGapNote",
  props: {
    gap: { type: Object, required: true },
    /* The panel names the type in its own heading. */
    showType: { type: Boolean, default: true },
  },
  data() {
    return { TONE_WORDS };
  },
  methods: {
    channelLabel,
    either(words) {
      if (words.length < 2) return words.join("");
      return words.slice(0, -1).join(", ") + " or " + words[words.length - 1];
    },
  },
};
</script>

<style scoped>
.kf-gap-note {
  line-height: 1.5;
}
.kf-gap-note__row {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 8px;
  margin-top: 4px;
}
.kf-gap-note__label {
  flex: 0 0 auto;
  min-width: 150px;
  font-weight: 600;
  color: #54636f;
}
.kf-gap-note__why {
  margin: 0;
  padding-left: 18px;
}
.kf-code {
  padding: 0 5px;
  border-radius: 4px;
  background: #eef3f8;
  color: #194e76;
  font-size: 0.86em;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  overflow-wrap: anywhere;
}
.kf-muted {
  color: #54636f;
}
@media (max-width: 599px) {
  .kf-gap-note__label {
    min-width: 0;
    flex-basis: 100%;
  }
}
</style>
